import BaseProxy from '../base-proxy';

/**
 * Class UnpublishInvoiceProxy
 */
class UnpublishInvoiceProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/invoices/unpublish', parameters);
    this.defaultOptions = { allowToast: false };
  }
  prepareRelease(invoiceId, options = {}) {
    return this.submit('get', `${this.endpoint}/prepare-release/${invoiceId}`, null, { ...this.defaultOptions, ...options });
  }

  /**
   * 
   * @param {number[]} ids 
   * @returns 
   */
  bulkDelete(ids) {
    return this.submit('post', `${this.endpoint}/bulk-delete`, { list_invoice_id: ids });
  }

  /**
   * 
   * @param {number} id 
   * @returns 
   */
  deleteInvoice(id, options = {}) {
    return this.submit('delete', `${this.endpoint}/delete/${id}`, null, options);
  }

  releaseUnpublishInvoice(payload, uploadStatus) {
    const formData = new FormData();
    if (payload.ca_type && payload.ca_type === 'HSM') {
      formData.append('ca_id', payload.ca_id);
      formData.append('ca_type', payload.ca_type);
    } else {
      formData.append('invoice_id', payload.id);
      formData.append('signed_xml', payload.xml);
      formData.append('signed_pdf', payload.pdf);
    }
    return this.submit('post', `${this.endpoint}/release/${payload.id}`, formData, {
      ...this.defaultOptions,
      onUploadProgress(progressEvent) {
        uploadStatus.percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default UnpublishInvoiceProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/unpublish-invoice-proxy.js